<template>
  <div style="background: white;">
    <div v-if="initok">
      <div class="top"><router-link to="/Index"><i  class="iconfont icon-fanhui fl" @click="$emit('show')"></i>已收藏</router-link></div>
      <div  v-if="!noList">
        <div class="list_block" v-for="(item1,index1) in data.catalogList" v-if="item1.items2.length>0">
          <div class="title">{{item1.Name}}</div>
          <div class="list cf">
            <div class="one"  @click="showCodeFn(item,index)" v-for="(item,index) in item1.items2">
              <div class="img"><img :style="{transform: item.Icon==2?'scale(0.7,0.7)':''}" :src="`https://resource.yatiku.com/resources/sendInformation/imgs/img${item.Icon}.png`"  /></div>
              <div class="text">{{item.Name}}</div>
            </div>
          </div>
        </div>
      </div>
      <div  style="background: white; " v-else>暂无收藏</div>
      <my-dialog @close="show=false" @saveCode="info='二维码保存成功'" @dealColTrue="dealCol(true)" @dealColFalse="dealCol(false)" :wxcode="wxcode" :variable="data.variable" :looking="looking" v-show="show"></my-dialog>
    </div>
    <div v-else><loading></loading></div>
    <alert :con="info"></alert>
  </div>
</template>

<script>
import {findId , dealCol} from '@/components/public.js'
import Alert from '@/components/Alert'
import Loading from '@/components/Loading'
import myDialog from '@/components/Dialog'
import '@/styles/public.less'
export default {
  components: {
    Alert,Loading,myDialog
  },
  data () {
    return {
      posNames: [],
      posNow: 0,
      collectShow: false,
      show: false,
      data: {},
      wxcode: '',
      looking: {},
      initok: false,
      info: '',
      catalogList: [],
      noList: true,
    }
  },
  methods: {
    dealCol () {
      dealCol(this,this.looking);
    },
    showCodeFn (item,index) {
      this.looking = item;
      this.show = true;
    },
    getdata () {
      this.axios.get(
        'http://app.yatiku.com/app/getActivityAllSendInformation',
        {params: {catalogId, codeId}}
      ).then((res) => {
        let ids = (local.getItem('IndexIds')||'').split(',');
        let catalogList = res.data.catalogType.catalogList;
        let items2 = [];
        if (catalogList.length>0)
        {
          for (let i = 0;i < catalogList.length ;i++ )
          {
            for (let j = 0;j < catalogList[i].items.length ;j++ )
            {
              //已收藏
              console.info(findId(ids,catalogList[i].items[j].Id));
              if (findId(ids,catalogList[i].items[j].Id)!==false)
              {
                this.noList = false;  
                catalogList[i].items[j].collected = true;
                items2.push(catalogList[i].items[j])
              }
            }
            catalogList[i].items2 = items2;
            items2 = [];
          }
        }
        this.data = res.data.catalogType;
        this.wxcode = this.wxcode||res.data.wxcode;
        this.initok = true;
      })
    }
  },
  mounted () {
    this.wxcode = local.getItem('IndexWxcode');
    this.getdata();
  }
}
</script>

<style lang="less" scoped>
  .top{
    background: #F2F2F2;
    text-align: center;
    font-size: 20px;
    line-height: 44px;
    margin-bottom: 20px;
    position: relative;
    i{
      font-size: 24px;
      position: absolute;
      left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Collected.vue